<template>
  <div class="animated fadeIn">
    <div class="card card-green">
      <div class="card-body">
        <div class="row mb-2">
            <div class="col-2">
              <b-form-checkbox plain v-model="pagination.showInactive" name="checkboisActive" :value="1"
                :unchecked-value="0">{{ $t('SHOWINACTIVE') }}
              </b-form-checkbox>
            </div>
            <div class="col-10">
              <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{ $t('NEW')
              }}</button>
            </div>
        </div>
        <div class="row">
          <div class="col-sm-6  table-responsive">
            <table class="table table-bordered table-striped table-hover table-sm table-logoped">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    {{ $t('TITLE') }}
                  </th>
                  <th>{{ $t('ACTION') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in leftColumnItems">
                  <tr :key="item.privateNotificationId" aria-rowindex="1" class=" table-ellipsis">
                    <td>
                      <icon v-if="item.isExpanded === false" @click="item.isExpanded = true" icon="plus"
                        class="hover-mouse"></icon>
                      <icon v-if="item.isExpanded === true" @click="item.isExpanded = false" icon="minus"
                        class="hover-mouse"></icon>
                    </td>
                    <td>{{ item.title }}</td>
                    <td>
                      <button type="button" class="btn button-edit mr-2" @click="showModal(item)">{{ $t('EDIT')
                      }}</button>
                      <button type="button" class="btn button-dlt" @click="deleteRow(item.privateNotificationId)">{{ $t('DELETE')
                      }}</button>
                    </td>
                  </tr>
                  <tr v-if="item.isExpanded === true" :key="`${item.privateNotificationId}_sec`" class=" table-ellipsis">
                    <td></td>
                    <td v-html="item.message" colspan="2"></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
            <div class="col-sm-6  table-responsive">
                <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                    <thead>
                    <tr>
                        <th></th>
                        <th>
                            {{ $t('TITLE') }}
                        </th>
                        <th>{{ $t('ACTION') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="item in rightColumnItems">
                        <tr :key="item.privateNotificationId" aria-rowindex="1" class=" table-ellipsis">
                            <td>
                                <icon v-if="item.isExpanded === false" @click="item.isExpanded = true" icon="plus"
                                      class="hover-mouse"></icon>
                                <icon v-if="item.isExpanded === true" @click="item.isExpanded = false" icon="minus"
                                      class="hover-mouse"></icon>
                            </td>
                            <td>{{ item.title }}</td>
                            <td>
                                <button type="button" class="btn button-edit mr-2" @click="showModal(item)">{{ $t('EDIT')
                                    }}</button>
                                <button type="button" class="btn button-dlt" @click="deleteRow(item.privateNotificationId)">{{ $t('DELETE')
                                    }}</button>
                            </td>
                        </tr>
                        <tr v-if="item.isExpanded === true" :key="`${item.privateNotificationId}_sec`" class=" table-ellipsis">
                            <td></td>
                            <td v-html="item.message" colspan="2"></td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <div class="col-sm-12">
                <nav>
                    <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData">
                    </pagination>
                </nav>
            </div>
        </div>
      </div>
    </div>
    <NotificationForm v-model="formData" v-on:close="formData = null; getData()" />
  </div>
</template>

<script>
import Api from '@/api/private_notifications/Notifications.js';
import NotificationForm from './Form.vue';

export default
  {
    name: 'TherapyType',
    components:
    {
      NotificationForm,
    },
    data() {
      return {
        response:
          {},
        formData: null,
        pagination:
        {
          query: '',
          currentPage: 1,
          limit: 50,
          searchTimeout: false,
          showInactive: 0,
        },
      };
    },
    created() {
      const me = this;
      me.getData();
    },
    methods:
    {
      async getData() {
        const me = this;
        try {
          const data = await Api.selectRow(me.getParams);
          if (data.error && data.error === true) {
            me.$notify.notice(data);
            me.loading = false;
            return;
          }

          for (const item of data.root) {
            item.isExpanded = false;
          }

          me.response = data;
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },
      async deleteRow(id) {
        const me = this;
        try {
          me.$store.commit('setModalAlert',
            {
              text: me.$i18n.t('AREYOUSHURE'),
              async btnAction() {
                const data = await Api.deleteRow(
                  {
                    id,
                  },
                );
                me.$notify.notice(data);
                await me.getData();
              },
            });
        }
        catch (e) {
          me.$notify.notice(e);
        }
      },
      showModal(item) {
        const me = this;
        let data = {};
        if (typeof item !== 'undefined') {
          data = { ...item };
        }

        me.formData = data;
      },
    },
    watch:
    {
      'pagination.limit'() {
        const me = this;
        me.getData();
      },
      'pagination.currentPage'() {
        const me = this;
        me.getData();
      },
      'pagination.showInactive'() {
        const me = this;
        me.getData();
      },
      'pagination.query'() {
        const me = this;

        if (me.pagination.searchTimeout !== false) {
          clearTimeout(me.pagination.searchTimeout);
        }

        me.pagination.searchTimeout = setTimeout(() => {
          me.getData();
          me.pagination.searchTimeout = false;
        }, 300);
      },
    },
    computed:
    {
      getParams() {
        const me = this;
        const data = {
          ...me.pagination,
        };
        data.start = (data.currentPage - 1) * data.limit;
        return data;
      },
        leftColumnItems() {
            if (this.response == null || this.response.root == null) {
                return [];
            }

            const midpoint = Math.ceil(this.response.root.length / 2);
            return this.response.root.slice(0, midpoint);
        },
        // Split data into right column
        rightColumnItems() {
            if (this.response == null || this.response.root == null) {
                return [];
            }
            const midpoint = Math.ceil(this.response.root.length / 2);
            return this.response.root.slice(midpoint);
        }
    },
  };
</script>
